import { ReportAllocatedAndSubsidies41Container } from "../../../containers/SupportSystem/Reports/ReportAllocatedAndSubsidies41Container";
export function ReportAllocatedAndSubsidies41Page() {
    return (
        <ReportAllocatedAndSubsidies41Container />
    );

}